<template>
    <div id="DefaultFooter">
        <div class="container">
            <div class="row">
               <div class="col-lg-4">
                  <div class="logo">
                    <img src="../assets/logo-white.svg" alt="logo"/>
                  </div>
                  <div class="business-terms">{{$t('footer.business_terms')}}</div>
                  <div class="contact mt-3 mt-md-1">
                    <div class="primary-heading">{{$t('footer.contact')}}</div>
                    <div class="pt-1 pb-1 hotline">
                      <span class="text-white font-weight-bold">Hotline:</span> +84 28 3535 4030
                    </div>
                    <div class="pt-1 pb-1 hotline">
                      <span class="text-white font-weight-bold">Zalo:</span> +84 777 35 4030
                    </div>
                    <div class="pt-1 pb-1 email">
                      <span class="text-white font-weight-bold">Email:</span> support@oddjob.vn
                    </div>
                 </div>
               </div>
               
               <div class="col-lg-4">
                  <div class="address mt-3 mt-md-1">
                    <div class="primary-heading">{{$t('footer.address')}}</div>
                    <div class="headquarters">
                       <div class="text-white font-weight-bold">{{$t('footer.address_headquarters')}}</div>
                       <div>
                            {{ $t('footer.address_headquarters_detail') }}
                       </div>
                    </div>
                    <div class="operate mt-2 mt-md-1">
                       <div class="text-white font-weight-bold">{{$t('footer.department')}}</div>
                       <div>
                          {{ $t('footer.department_detail') }}
                       </div>
                    </div>
                  </div>
               </div>
               <div class="col-lg-2">
                  <div class="info mt-3 mt-md-1">
                      <div class="primary-heading">{{$t('footer.information')}}</div>
                      <ul>
                          <router-link tag="li" class="col" :to="{ name: 'PrivacyPolicy' }" exact>{{$t('footer.privacy_policy')}}</router-link>
                          <router-link tag="li" class="col" :to="{ name: 'TermsOfUse' }" exact>{{$t('footer.terms_of_use')}}</router-link>
                          <router-link tag="li" class="col" :to="{ name: 'Faqs' }" exact>{{$t('footer.faqs')}}</router-link>
                      </ul>
                      <!-- <div>
                          <router-link :to="{ name: 'PrivacyPolicy' }" alt="Chính sách bảo mật">Chính sách bảo mật</router-link>
                      </div>
                      <div>
                          <router-link :to="{ name: 'TermsOfUse' }" alt="Điều khoản sử dụng">Điều khoản sử dụng</router-link>
                      </div>
                      <div>
                          <router-link :to="{ name: 'Faqs' }" alt="Câu hỏi thường gặp">Câu hỏi thường gặp</router-link>
                      </div> -->
                  </div>
               </div>
               <div class="col-lg-2">
                  <div class="download-app mt-3 mt-lg-1">
                    <div class="primary-heading">{{$t('footer.download_app')}}</div>
                    <div class="d-flex flex-lg-column">
                      <a ref="googlePlay"  class="google-play" href="https://play.google.com/store/apps/details?id=vn.oddjob.app">
                        <img class="w-100" src="../assets/google-play.svg" alt="google play"/>
                      </a>
                      <a ref="appStore" class="app-store ml-3 ml-lg-0 mt-lg-2" href="https://apps.apple.com/vn/app/oddjob-vn/id1520359924">
                        <img class="w-100" src="../assets/app-store.svg" alt="app store">
                      </a> 
                    </div>
                  </div>
               </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return {

    }
  }
}
</script>

<style scoped lang="scss">
$radius: 40px;
#DefaultFooter {
  padding: 60px 0;
  background-color: #ffbe17;
  border-radius: 0 $radius 0 0;
  font-size: 12px;
  line-height: 24px;
  .primary-heading{
    font-weight: bold;
    font-size: 16px;
    padding:7px 5px 10px 0px;
  }
  .business-terms{
     font-size: 12px;
     padding-top: 20px;
  }
  .contact{
    .hotline{
        font-size: 14px;
        // font-weight: bold;
    }
    .email{
        font-size: 14px;
        // font-weight: bold;
    }
  }
  .address{
    // font-weight: bold;
    .headquarters{
      font-size: 14px;
    }
    .operate{
      font-size: 14px;
    }
  }
  .info{
    ul{
      list-style-type: none;
      font-size: 14px;
      margin: 0px;
      padding: 0px;
      line-height: 24px;
      li{
         padding: 0px;
         margin: 0px;
         cursor: pointer;
         a{
            color: black;
            text-decoration: none;
            font-size: "Open Sans";
         }
         &:hover{
           font-weight: bold;
         }
      }
    }
    .router-link-exact-active{
      font-weight: bold;
      font-size: "Open Sans";
    }
 
  }
  .download-app{
    .google-play{
      max-width: 150px;
    }
    .app-store{
      max-width: 150px;
    }
  }
}
@media screen and (min-width: 992px){

}
</style>